import ProviderEngine from 'web3-provider-engine';
import SubscriptionSubprovider from 'web3-provider-engine/subproviders/subscriptions.js';
import DefaultFixture from 'web3-provider-engine/subproviders/default-fixture.js';
import NonceTrackerSubprovider from 'web3-provider-engine/subproviders/nonce-tracker.js';
import SanitizingSubprovider from 'web3-provider-engine/subproviders/sanitizer.js';
import FetchSubprovider from 'web3-provider-engine/subproviders/fetch.js';
import SafeSubprovider from './SafeSubprovider';

var SafeProvider = function SafeProvider(_ref) {
  var rpcUrl = _ref.rpcUrl;
  var engine = new ProviderEngine();
  engine.setMaxListeners(0); // Metamask methods are temporary. Must be deleted in the future.

  engine.isMetaMask = !0;
  engine._metamask = {
    isApproved: function isApproved() {
      return true;
    },
    isUnlocked: function isUnlocked() {
      return true;
    },
    isEnabled: function isEnabled() {
      return true;
    }
  };
  engine.constructor = {
    name: 'SafeWeb3Provider'
  };
  engine.isSafe = true;

  engine.isConnected = function () {
    return true;
  };

  engine.addProvider(new SafeSubprovider()); // static

  var staticSubprovider = new DefaultFixture();
  engine.addProvider(staticSubprovider); // nonce tracker

  engine.addProvider(new NonceTrackerSubprovider()); // sanitization

  var sanitizer = new SanitizingSubprovider();
  engine.addProvider(sanitizer);
  var filterAndSubsSubprovider = new SubscriptionSubprovider({
    maxFilters: 100
  }); // forward subscription events through provider

  filterAndSubsSubprovider.on('data', function (err, notification) {
    engine.emit('data', err, notification);
  });
  engine.addProvider(filterAndSubsSubprovider);
  engine.addProvider(new FetchSubprovider({
    rpcUrl: rpcUrl
  }));

  var sendAsync = function sendAsync(payload, cb) {
    engine.sendAsync(payload, cb);
  };

  var sendSync = function sendSync(payload) {
    var result;

    switch (payload.method) {
      case 'eth_accounts':
        result = engine.currentSafe ? [engine.currentSafe] : [];
        break;

      case 'eth_coinbase':
        result = engine.currentSafe || null;
        break;

      case 'eth_uninstallFilter':
        sendAsync(payload, function () {});
        result = true;
        break;

      default:
        throw new Error('SafeProvider does not support this synchronous request', payload);
    }

    return {
      id: payload.id,
      jsonrpc: payload.jsonrpc,
      result: result
    };
  };

  engine.send = function (payload, callback) {
    if (callback) {
      sendAsync(payload, callback);
    } else {
      return sendSync(payload);
    }
  };

  engine.enable = function () {
    return new Promise(function (resolve, reject) {
      sendAsync({
        method: 'eth_accounts',
        params: []
      }, function (error, response) {
        if (error) {
          reject(error);
        } else {
          resolve(response);
        }
      });
    });
  };

  window.addEventListener('EV_SAFE_UPDATE_PROVIDER', function (data) {
    engine.currentSafe = data.detail;
  });
  var safeProviderReadyEvent = new window.CustomEvent('EV_SAFE_PROVIDER_READY');
  window.dispatchEvent(safeProviderReadyEvent);
  engine.start();
  return engine;
};

export default SafeProvider;